// @flow
import { Empty } from 'antd'
import * as React from 'react'

import { FormBuilderContext } from '@/pages/Contexts/FormBuilderContext'
import FormAntd from '@/ui/form/antd/FormAntd'

import type { Question } from '../../types/question'
import { buildQuestionTree } from './utils'

type Props = {
  addField: (string) => void,
  questions: Question[],
  disabled?: boolean,
  onChange?: (value: string) => void,
}

function CalculationAddField({
  addField,
  questions,
  disabled,
  onChange,
}: Props): React.Node {
  const { getCurrentQuestion } = React.useContext(FormBuilderContext)
  function onAddField(value: number) {
    addField?.(value?.toString())
    onChange?.(value?.toString())
  }
  const currentQuestion = getCurrentQuestion()

  const options = React.useMemo(
    () => buildQuestionTree(questions, currentQuestion),
    [questions, currentQuestion]
  )

  return (
    <FormAntd.TreeSelect
      treeDefaultExpandAll
      disabled={disabled}
      notFoundContent={
        <Empty description="No fields" image={Empty.PRESENTED_IMAGE_SIMPLE} />
      }
      onChange={onAddField}
      placeholder="Add field to calculation"
      renderSelectedItem={() => null}
      tabIndex={-1}
      treeData={options}
      treeNodeFilterProp="title"
      value={null}
      virtual={false}
    />
  )
}

export default CalculationAddField
